
import { onBeforeMount, onMounted, ref, reactive, computed, inject, watch, nextTick } from 'vue'
import { nativeToast, playVideo } from '@/utils/nativeFn'
import { queryVideoInfo } from '@/api/aio'
export default {
    name: 'TaskProgress',
    props: {
        progressData: {
            type: Object,
            default: () => ({})
        },
    },
}

